import { render, staticRenderFns } from "./VerEditarModal.vue?vue&type=template&id=75603eae&"
import script from "./VerEditarModal.vue?vue&type=script&lang=ts&"
export * from "./VerEditarModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports